// extracted by mini-css-extract-plugin
module.exports = {"button":"AudioSample_button__qZfYo","root":"AudioSample_root__6ku4x"};